<div class="main-container">
  <div class="announcement-view">
    <app-announcement-view></app-announcement-view>
  </div>
  <div class="header">
    <app-header></app-header>
  </div>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <div class="footer">
    <app-footer></app-footer>
  </div>
</div>